import {KnowledgeObject} from "../domain/entities/knowledge-object.entity";
import {AbstractCommand} from "./abstract.command";
import {CommandName} from "./command-name.enum";

/**
 * Command to create a new KnowledgeObject entity (PRD-066).
 *
 * The payload is the freshly built entity (client-generated ShortId UID). The
 * generic command-to-dto transformer serializes NEW entities via
 * `instanceToPlain(..., { excludeExtraneousValues: true })` — therefore ONLY
 * fields carrying a class-transformer `@Expose()` decorator are emitted.
 * `KnowledgeObject` exposes `uid` (base class), `type` and `title`, producing
 * the `{ uid, type, title }` shape the backend
 * `CreateKnowledgeObjectCommandHandler` reads.
 */
export class CreateKnowledgeObjectCommand extends AbstractCommand<KnowledgeObject> {

    public name: CommandName = CommandName.CREATE_KNOWLEDGE_OBJECT;

    public tags = ['entity', 'create', 'knowledge-object'];

    constructor(payload: KnowledgeObject) {
        super('knowledgeObject', payload.uid, payload);
    }

}
